// Action creators
import getProfileFetch from './profile_actions';

var userLoginAndProfile = user => {
    return (dispatch, getState) => {
        return dispatch(userLoginFetch(user)).then(() => {
        });
    }
}

var userLoginFetch = user => {
    return dispatch => {
        return fetch("api/auth/login", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            body: JSON.stringify({ email: user.email, password: user.password })
        })
            .then(resp => resp.json())
            .then(data => {
                console.log("data in user_action: ", data);
                if (data.message) {
                    // Here you should have logic to handle invalid login credentials.
                    // This assumes your Rails API will return a JSON object with a key of
                    // 'message' if there is an error
                } else if (data.token !== undefined) {
                    console.log("Setting token here");
                    localStorage.setItem("token", data.token);
                    localStorage.setItem("currentUser", data.id);
                    localStorage.setItem("justLoggedIn", true);
                    //dispatch(loginUser(data));
                }
            })
    }
}

// .then(res => dispatch(getProfileFetch['LOAD_PROFILE']))

var userLoggedIn = () => {
    return dispatch => {
        if (localStorage.getItem('currentUser') !== null && localStorage.getItem('token') !== null) {
            dispatch(loginUser({ 'token': localStorage.getItem('token'), 'id': localStorage.getItem('currentUser') }));
        }
    }
}

var updateManageUser = user => {
    return dispatch => {
        const token = localStorage.token;
        if (token) {
            console.log("updateManageUser");
            return fetch("api/user/UpdateManageUser", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(user)
            })
                .then(resp => resp.json())
                .then(data => {
                    if (data.message) {
                        // An error will occur if the token is invalid.
                        // If this happens, you may want to remove the invalid token.
                        localStorage.removeItem("token")
                    } else {
                        console.log(data);
                    }
                })
        }
    }
}

var createManageUser = user => {
    return dispatch => {
        console.log(user);
        const token = localStorage.token;
        if (token) {
            console.log("updateManageUser");
            return fetch("api/user/CreateManageUser", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(user)
            })
                .then(resp => resp.json())
                .then(data => {
                    if (data.message) {
                        // An error will occur if the token is invalid.
                        // If this happens, you may want to remove the invalid token.
                        localStorage.removeItem("token")
                    } else {
                        console.log(data);
                    }
                })
        }
    }
}

var deleteManageUser = user => {
    return dispatch => {
        const token = localStorage.token;
        if (token) {
            console.log("updateManageUser");
            return fetch("api/user/DeleteManageUser", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(user)
            })
                .then(resp => resp.json())
                .then(data => {
                    if (data.message) {
                        // An error will occur if the token is invalid.
                        // If this happens, you may want to remove the invalid token.
                        localStorage.removeItem("token")
                    } else {
                        console.log(data);
                    }
                })
        }
    }
}

// Updates user's LastSeen to current time & Stamp to 'validLogout'
var updateLastSeen = (updateStamp = true) => {
    console.log("updateLastSeen executed");
    // if param is not undefined
    return dispatch => {
        const token = localStorage.token;
        console.log("updateLastSeen token: ", token);
        if (token) {
            return fetch("api/user/UpdateLastSeen", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: updateStamp
            })
                .then(data => {
                    console.log("updateLastSeen .then");
                    if (data.message) {
                        console.log("updateLastSeen failed data.message: ", data.message);
                        // An error will occur if the token is invalid.
                        // If this happens, you may want to remove the invalid token.
                        localStorage.removeItem("token")
                    } else {
                        console.log("updateLastSeen success data: ", data);
                    }
                })
        }
    }
}


var updateStamp = () => {
    return dispatch => {
        const token = localStorage.token;
        console.log(token);
        if (token) {
            return fetch("api/user/UpdateStamp", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            })
                .then(data => {
                    if (data.message) {
                        // An error will occur if the token is invalid.
                        // If this happens, you may want to remove the invalid token.
                        localStorage.removeItem("token")
                    } else {
                        console.log(data);
                    }
                })
        }
    }
}

var getUnreadMessagesFromDb = () => {
    return dispatch => {
        const token = localStorage.token;
        if (token) {
            console.log("get unread messages from db");
            return fetch("api/user/GetUnreadMessages", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            }).then(results => {
                return results.json();
            })
                .then(results => {
                    dispatch({ type: "UNREAD_MESSAGE_FETCH", payload: results });
                })
        }
    }
}

var getUnreadMessageUserFromDb = () => {
    return dispatch => {
        const token = localStorage.token;
        if (token) {
            console.log("get unread message users from db");
            return fetch("api/user/GetUnreadMessages", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            }).then(results => {
                return results.json();
            })
                .then(results => {
                    dispatch({ type: "UNREAD_MESSAGE_USER_FETCH", payload: results });
                })
        }
    }
}

var setDisconnected = (bool) => {
  return function (dispatch) {
    dispatch({ type: "SET_DISCONNECTED", payload: { 'setDisconnected': bool } });
  };
}

var updateUnreadMessage = (post) => {
    return dispatch => {
        dispatch(setUnreadMessage({ 'post': post }));
    }
}

var updateReadMessage = (userId) => {
    return dispatch => {
        dispatch(readMessage({ 'userId': userId }));
    }
}

const loginUser = userObj => ({
    type: 'LOGIN_USER',
    payload: userObj
})

const setUnreadMessage = postObj => ({
    type: 'UNREAD_MESSAGE',
    payload: postObj
})

const readMessage = userId => ({
    type: 'READ_MESSAGE',
    payload: userId
})

export default {
    'USER_FETCH': userLoginFetch,
    'USER_LOGGED_IN': userLoggedIn,
    'USER_LOGIN_AND_PROFILE': userLoginAndProfile,
    'UPDATE_MANAGE_USER': updateManageUser,
    'UPDATE_LAST_SEEN': updateLastSeen,
    'UPDATE_STAMP': updateStamp,
    'SET_UNREAD_MESSAGE': updateUnreadMessage,
    'READ_MESSAGE': updateReadMessage,
    'CREATE_MANAGE_USER': createManageUser,
    'DELETE_MANAGE_USER': deleteManageUser,
    'UNREAD_MESSAGE_FETCH': getUnreadMessagesFromDb,
    'UNREAD_MESSAGE_USER_FETCH': getUnreadMessageUserFromDb,
    'SET_DISCONNECTED': setDisconnected
};


// WEBPACK FOOTER //
// ./src/actions/user_actions.js


// WEBPACK FOOTER //
// ./src/actions/user_actions.js